import { render, staticRenderFns } from "./App.vue?vue&type=template&id=f96827f2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=f96827f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../environment/web_node_modules/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports